import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "lib-flexible";
import axios from "axios";
import {
  post,
  fetch,
  get,
  patch,
  put
} from "@/assets/js/http.js";
// import "animate.css";
import {
  Button,
  RadioGroup,
  Radio,
  Form,
  Field,
  CellGroup,
  Icon,
  Uploader,
  Checkbox
} from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// 导入组件库
import VueCanvasPoster from 'vue-canvas-poster'
// 注册组件库
Vue.use(VueCanvasPoster)

Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Form);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Uploader);
Vue.use(Icon);
Vue.use(Checkbox);

if (module.hot) {
  module.hot.accept();
}


Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$get = get;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;

// Vue.prototype.$api = "https://v5v2540972.goho.co";
Vue.prototype.$api = "http://59.110.51.52:8010";
// Vue.prototype.$api = "http://192.168.0.102:8001";
Vue.config.productionTip = false;

//全局前置路由守卫---初始化的时候被调用、每次路由切换的时候被调用
router.beforeEach((to, from, next) => {
  // console.log(to);
  // 页面跳转/切换时 滚动条回到顶部
  document.documentElement.scrollTop = 0
  let allowBack = true; //    给个默认值true
  if (to.meta.allowBack !== undefined) {
    allowBack = to.meta.allowBack;
  }
  if (!allowBack) {
    history.pushState(null, null, location.href);
  }
  store.commit("setPageName", to.path);
  // store.dispatch('updateAppSetting', {
  //   allowBack: allowBack
  // })
  next();
});

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount("#app");
